<template>
    <section class="padding-vertical-content" id="paso1">
        <ContentOrLoading :style="loading ? 'padding: 200px;' : ''">
            <div class="container" v-if="!loading">
                <div class="row align-items-center">
                    <div :class="recuperarSoloZonaAnexas ? 'col-7 col-md-6' : 'col-12'">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.selecciona_sector') }}</h2>
                    </div>
                    <div class="col-5 col-md-6 pl-0" v-if="recuperarSoloZonaAnexas">
                        <Button @click="continuarSinPlazaParking">{{ $t('nuevo_abono.no_parking') }}</Button>
                    </div>
                    <div class="col-12">
                        <div class="svg-container mb-4 mb-lg-5">
                            <ContentOrLoading :style="loading ? 'padding: 200px;' : ''">
                                <transition name="fade" mode="out-in" v-if="!loading && !loadingAnexas">
                                    <ContentOrLoading>
                                        <div class="row" v-if="!loading && !loadingAnexas" key="zonas" id="zonas">
                                            <!-- Overlay de bloqueo cuando disabled -->
                                            <div v-if="disabled" class="tw:w-full tw:mb-4 tw:mt-3">
                                                <div class="tw:bg-slate-100 tw:border tw:border-slate-300 tw:rounded-lg tw:p-4 tw:text-center tw:flex tw:items-center tw:justify-center tw:gap-3">
                                                    <i class="material-icons tw:text-slate-400">lock</i>
                                                    <span class="tw:text-slate-500 tw:font-medium">{{ $t('nuevo_abono.bloquear_seleccion') || 'Selección bloqueada. Completa el paso actual para continuar.' }}</span>
                                                </div>
                                            </div>

                                            <div class="col-lg-8" :class="{ 'tw:opacity-50 tw:pointer-events-none': disabled }">
                                                <h3 class="subtitle h4 light mb-3 mb-lg-4">A) {{ $t('nuevo_abono.pinchando_mapa') }}:</h3>
                                                <div class="lightgray-content mb-3 mb-lg-4">
                                                    <SvgComponent 
                                                        :zonas="zonas" 
                                                        :place="recinto" 
                                                        @clickZona="clickZona"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-4" :class="{ 'tw:opacity-50 tw:pointer-events-none': disabled }">
                                                <h3 class="subtitle h4 light mb-3 mb-lg-4 ">B) {{ $t('nuevo_abono.tabla') }}:</h3>
                                                <div class="lightgray-content p-2 pb-0">
                                                    <TablaSectoresComponent :zonas="zonas" @clickZona="clickZona"/>
                                                </div>
                                            </div>
                                        </div>
                                    </ContentOrLoading>
                                </transition>
                            </ContentOrLoading>
                        </div>
                    </div>
                </div>
            </div>
        </ContentOrLoading>
    </section>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        props: {
            abonado: {
                required: false,
                type: Object
            },
            recuperarSoloZonaAnexas: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                loadingAnexas: false,
                zonas: [],
                zonas_anexas: [],
                zona: null,
                n_abonos: 0,
                datos_compradores: [],
                asientos: []
            }
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            renovacion() {
                return this.$route.query.dni || this.$route.query.n_abonado_antiguo ? 1 : 0;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            generos() {
                return this.$store.getters.getGeneros;
            },
        },
        created() {
            if (this.recuperarSoloZonaAnexas) {
                this.getRegionesAnexas();
            } else {
                this.getRegionesAnexas();
                this.getZonas();
            }
        },
        methods: {
            getRegionesAnexas() {
                this.loadingAnexas = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: this.renovacion
                    },
                    lista_id: this.lista_abonados.id,
                    recinto_id: this.recinto.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.regiones.anexas'), params).then(res => {
                    let anexas = res.data.data;
                    this.zonas_anexas = anexas;

                    anexas.forEach(zona => {
                        zona.precios = []; 
                        zona.tipos_abonos.forEach(precio => {
                            zona.precios = zona.precios.concat(precio.descuentos);
                        });
                    });

                    if (this.recuperarSoloZonaAnexas) {
                        this.zonas = anexas;
                    } else {
                        this.zonas = this.zonas.concat(anexas);
                    }

                    if(this.$route.query.region_id) {
                        let zona = anexas.find(({id}) => parseInt(id) === parseInt(this.$route.query.region_id));

                        if(zona) {
                            this.clickZona(zona);
                        }
                    }

                }).finally(() => this.loadingAnexas = false);
            },
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: this.renovacion
                    },
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = this.zonas.concat(res.data.data);
                    
                    if(this.$route.query.region_id) {
                        let zona = this.zonas.find(({id}) => parseInt(id) === parseInt(this.$route.query.region_id));

                        if(zona) {
                            this.clickZona(zona);
                        }
                    }
                }).finally(() => this.loading = false);
            },
            clickZona(zona) {
                if (this.disabled) return;

                this.zona = zona;

                if(!this.zona.with_seats) {
                    if(this.abonado) {
                        var comprador = {
                            nombre: this.abonado.name,
                            apellidos: this.abonado.surnames,
                            dni: this.abonado.dni,
                            fecha_nacimiento: this.abonado.fecha_nacimiento,
                            email: this.abonado.email,
                            telefono: this.abonado.telefono,
                            provincia: this.abonado.provincia,
                            localidad: this.abonado.localidad,
                            domicilio: this.abonado.domicilio,
                            cp: this.abonado.cp,
                            pais: this.abonado.pais,
                            genero: this.generos?.find(genero => genero.id === this.abonado.genero_id),
                            n_abonado_antiguo: this.abonado.n_abonado_antiguo,
                            penista: this.abonado.penista,
                            asiento: {
                                asiento: 0,
                                fila: 0,
                                zona_id: this.zona.id
                            },
                            importe_monedero: this.abonado.importe_monedero
                        };

                        this.n_abonos = 1;

                        this.datos_compradores.push(comprador);

                        this.asientos.push(comprador);

                        this.$emit('bloquearAsientos', this.datos_compradores, this.asientos, this.zona);
                        return;
                    }
                }

                this.$emit('zonaSeleccionada', this.zona, this.zonas_anexas);
            },
            continuarSinPlazaParking() {
                this.$emit('continuarSinPlazaParking');
            }
        },
        components: {
            SvgComponent, TablaSectoresComponent
        }
    }
</script>